export default __webpack_public_path__ + "static/media/forex_banner_mobile.9cb59eaf.png";